import { render } from "./RequestsOverview.vue?vue&type=template&id=acb904bc&scoped=true"
import script from "./RequestsOverview.vue?vue&type=script&lang=js"
export * from "./RequestsOverview.vue?vue&type=script&lang=js"

import "./RequestsOverview.vue?vue&type=style&index=0&id=acb904bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb904bc"]])

export default __exports__